import type { SortDirection } from '@/hooks/useTableControls';

interface SortableThProps {
  label: string;
  sortKey: string;
  activeKey: string;
  direction: SortDirection;
  onSort: (key: string) => void;
  align?: 'left' | 'right' | 'center';
  className?: string;
}

export default function SortableTh({
  label,
  sortKey,
  activeKey,
  direction,
  onSort,
  align = 'left',
  className = '',
}: SortableThProps) {
  const active = activeKey === sortKey;
  const alignment = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-start';

  return (
    <th
      className={[
        'px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-500',
        align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={[
          'group inline-flex w-full cursor-pointer items-center gap-1 transition-colors hover:text-foreground-800',
          alignment,
          active ? 'text-foreground-800' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        title={`Ordenar por ${label.toLowerCase()}`}
      >
        {label}
        <span className="flex h-4 w-4 items-center justify-center">
          <i
            className={
              active
                ? direction === 'asc'
                  ? 'ri-arrow-up-s-line text-sm'
                  : 'ri-arrow-down-s-line text-sm'
                : 'ri-expand-up-down-line text-xs opacity-40 group-hover:opacity-70'
            }
          ></i>
        </span>
      </button>
    </th>
  );
}